// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_2zaJr","bannerOpened":"_1_9wq","banner":"_1M7x2","title":"r4GbN","blockButtons":"_1_-0f"};